import {EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

export abstract class AbstractAction {
    @Output() public clicked$: EventEmitter<Event>;
    @HostBinding('class.disabled') @Input() public disabled: boolean;
    @HostBinding('attr.name') @Input() public title: string;

    constructor() {
        this.clicked$ = new EventEmitter<Event>();
    }

    /**
     * Emit a click event to control when it is enacted and deal
     * with states
     * @param event
     */
    @HostListener('click', ['$event'])
    public click(event: Event): void {
        if (this.disabled) {

        } else {
            this.clicked$.emit(event);
        }
    }
}
